<style lang="scss" scoped></style>

<template>
    <div class="reseller-login">
        <div class="container">
            <div class="row justify-center">
                <div class="md:w-1/2 lg:w-5/12 w-full">
                    <div class="lg:px-20">
                        <div class="mb-20 text-center">
                            <h1 class="h4 mb-8">{{ translations.login_title }}</h1>
                            <p class="mb-0">{{ translations.login_description }}</p>
                        </div>

                        <div class="bg-blue rounded-xs text-14 flex items-center w-full px-16 py-16 font-medium leading-snug text-white" v-if="message != ''">{{ message }}</div>

                        <el-form class="mt-20 mb-24" @submit="submit" :loading="loading" :success="success" :error="server_error" button-class="btn btn-green btn-lg btn-rounded w-full mt-8 font-bold" :submit-text="translations.login_button">
                            <el-input v-model="formData.email" rules="required" :label="translations.login_field" class="mb-16"></el-input>
                            <el-input v-model="formData.password" type="password" rules="required" :label="translations.password_field" class="mb-16"></el-input>
                        </el-form>

                        <div class="text-center">
                            <a class="hover:border-transparent text-black transition-colors border-b border-black" href="/wachtwoord-vergeten">{{ translations.password_reset }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasForm from "@mixins/components/has-form";

export default {
    name: "Ui.ResellerLogin",

    mixins: [hasForm],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            message: "",
            formData: {
                email: "",
                password: ""
            }
        };
    },

    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const action = urlParams.get("action");

        if (action != null) {
            this.message = this.$t(`forms.login.messages.${action}`);
        }
    },

    methods: {
        submit() {
            this.beforeSubmit();

            axios
                .post("/api/login", this.formData)
                .then(response => {
                    this.handleSuccess();
                    window.location.replace("/producten");
                })
                .catch(e => this.handleError(e.response.data));
        }
    }
};
</script>
